import { useEffect, useLayoutEffect } from 'react';
import { isServer } from './isServer';
export const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;

//# sourceMappingURL=useIsomorphicLayoutEffect.js.map